'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pubSubClient = undefined;

var _handleActions;

var _reduxActions = require('redux-actions');

var _AsyncData = require('conversations-internal-schema/async-data/AsyncData');

var _AsyncData2 = _interopRequireDefault(_AsyncData);

var _requestFailed = require('conversations-internal-schema/async-data/operators/requestFailed');

var _requestSucceededWithOperator = require('conversations-internal-schema/async-data/operators/requestSucceededWithOperator');

var _requestStarted = require('conversations-internal-schema/async-data/operators/requestStarted');

var _asyncActionTypes = require('../constants/asyncActionTypes');

var _makeRequestActionTypes = require('conversations-internal-clients/action-creators/operators/makeRequestActionTypes');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var pubSubActions = (0, _makeRequestActionTypes.makeRequestActionTypes)(_asyncActionTypes.INITIALIZE_PUBSUB);

var initialState = (0, _AsyncData2.default)();

var pubSubClient = exports.pubSubClient = (0, _reduxActions.handleActions)((_handleActions = {}, _defineProperty(_handleActions, pubSubActions.STARTED, function (state) {
  return (0, _requestStarted.requestStarted)(state);
}), _defineProperty(_handleActions, pubSubActions.SUCCEEDED, function (state, action) {
  return (0, _requestSucceededWithOperator.requestSucceededWithOperator)(function () {
    return action.payload.client;
  }, state);
}), _defineProperty(_handleActions, pubSubActions.FAILED, function (state) {
  return (0, _requestFailed.requestFailed)(state);
}), _handleActions), initialState);


//////////////////
// WEBPACK FOOTER
// ./js/pubsub/reducers/pubSubClient.js
// module id = 1282
// module chunks = 3